import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import Nuclias from "const/nuclias";

export const initialState = {
  sp: null,
  si: null,
  selectedOrg: null,
  selectedStoreTag: null,
  selectedStore: null,
  orgTreeMap: null,
};

const pageContextSlice = createSlice({
  name: "pageContext",
  initialState,
  reducers: {
    cleanAll(state) {
      Object.assign(state, initialState);
    },
    setAll(state, action) {
      Object.assign(state, action.payload);
    },
  },
  extraReducers: {},
});

// The top organization that user is managed.
export const selectManagedOrg = (orgType) => (state) => {
  let managedOrg = null;

  switch (orgType) {
    case Nuclias.organizationType.sp:
      managedOrg = state.pageContext.sp;
      break;
    case Nuclias.organizationType.si:
      managedOrg = state.pageContext.si;
      break;
    default:
      managedOrg = state.pageContext.selectedOrg;
  }

  return managedOrg;
};

// The site tag that user is managed.
export const selectManagedSiteTag = (state) => state.pageContext.selectedStoreTag;

// The site that user is managed.
export const selectManagedSite = (state) => state.pageContext.selectedStore;

// What the type of this selected org in the dropdown list.
export const selectOrgLevel = (state) => {
  if (state.pageContext.selectedOrg) {
    return Nuclias.organizationType.org;
  } else if (state.pageContext.sp) {
    return Nuclias.organizationType.sp;
  } else if (state.pageContext.si) {
    return Nuclias.organizationType.si;
  }
};

// Which organization is selected in the dropdown list.
export const selectOrg = (isOrgLevel) => (state) => {
  let selectedOrg = null;

  if (!isOrgLevel) {
    selectedOrg = state.pageContext.sp || state.pageContext.si;
  } else {
    selectedOrg = state.pageContext.selectedOrg;
  }

  return selectedOrg;
}

export const pageContextActions = pageContextSlice.actions;

export default pageContextSlice;
